export default {
  id: 212,
  title: 'Target #212 - Fibonacci peacock',
  url: 'https://cssbattle.dev/play/212',
  colors: ['#FFED99', '#000000', '#9F3333', '#3F8627', '#F48B26'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[c],p[d]{top:61;background:#f48b26}p[a],p[e]{border-radius:0 0 9in}body{background:#ffed99}p{position:fixed;margin:0}p[a]{top:61;left:166;width:178;height:178;background:#3f8627}p[b]{top:129;left:56;width:110;height:110;background:#9f3333;border-radius:0 0 0 9in}p[c]{left:56;width:68;height:68;border-radius:9in 0 0}p[d]{left:120;width:46;height:42;border-radius:0 9in 0 0}p[e]{top:103;left:140;width:26;height:26;background:#000',
}
